// extracted by mini-css-extract-plugin
export default {"textField":"ModifyAccessLevel_textField__rb0T1","select":"ModifyAccessLevel_select__WiQb-","confirmBtn":"ModifyAccessLevel_confirmBtn__Dp5zg"};